module.exports = __webpack_public_path__ + "static/media/exploreButtonBackground.70b2660e.png";